export const COUNTDOWN_DURATION_MS = 125000;
export const COUNTDOWN_INITIAL_TIME = 125;
export const SECS_PER_HOUR = 60;
export const COUNTER = 1;
export const MILISECS = 1000;
export const SMS = 'sms';
export const EMAIL = 'e-mail';
